import React, { useState } from "react";
import { cowBreedAboutMap, buffaloBreedAboutMap } from "./breeds";

const getAboutText = (animal) => {
  const template =
    cowBreedAboutMap[animal.breed] || buffaloBreedAboutMap[animal.breed];

  if (!template) return "Learn more about the animals that provide your milk.";

  return template
    .replaceAll("{name}", animal.name || "our animal")
    .replaceAll(
      "{farmer}",
      animal.farmerObj?.farmerName || "our trusted farmer",
    );
};

const normalize = (v) =>
  v === null || v === undefined || v === "" || v === "null" ? "None" : v;

const CowCard = ({ cow }) => {
  const [activeTab, setActiveTab] = useState("health");

  return (
    <div className="cw-container">
      {/* Image */}
      <div className="cw-image-section">
        <div className="cw-image-overlay"></div>
        <img
          src={cow.img}
          alt={cow.name}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/img/breeds/Dummy.png";
          }}
        />

      </div>

      {/* Content */}
      <div className="cw-content">
        <div className="cw-details">
          <h2>{cow.name}</h2>
          <p>Cattle Registration No: {normalize(cow.regNo)}</p>
          <p>
            Breed: {normalize(cow.breed)} | DOB: {normalize(cow.dob)}
          </p>
        </div>

        {/* Tabs */}
        <div className="cw-tabs">
          <button
            className={`cw-tab ${activeTab === "health" ? "active" : ""}`}
            onClick={() => setActiveTab("health")}
          >
            Health Details
          </button>
          <button
            className={`cw-tab ${activeTab === "farmer" ? "active" : ""}`}
            onClick={() => setActiveTab("farmer")}
          >
            Farmer Details
          </button>
          <button
            className={`cw-tab ${activeTab === "about" ? "active" : ""}`}
            onClick={() => setActiveTab("about")}
          >
            About
          </button>
        </div>

        {/* Tab Content */}
        <div className="cw-tab-content">
          {activeTab === "about" && (
            <div
              style={{
                maxHeight: "120px",
                overflowY: "auto",
                paddingRight: "6px",
              }}
              className="cw-scroll"
            >
              <p>{getAboutText(cow)}</p>
            </div>
          )}

          {activeTab === "health" &&
            (cow.healthObj ? (
              <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                <li>
                  <b>Vaccinated:</b> {normalize(cow.healthObj.vaccinated)}
                </li>
                <li>
                  <b>Dewormed:</b> {normalize(cow.healthObj.dewormed)}
                </li>
                <li>
                  <b>Last Checkup:</b> {normalize(cow.healthObj.lastCheckup)}
                </li>
              </ul>
            ) : (
              <p>Details not available.</p>
            ))}

          {activeTab === "farmer" &&
            (cow.farmerObj ? (
              <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                <li>
                  <b>Farmer Name:</b> {normalize(cow.farmerObj.farmerName)}
                </li>
                <li>
                  <b>Farmer At:</b> {normalize(cow.farmerObj.farmerAt)}
                </li>
              </ul>
            ) : (
              <p>Details not available.</p>
            ))}
        </div>
      </div>
    </div>
  );
};

export default CowCard;
